<template>
    <sweet-modal blocking :title="$t('modal_shareProjectTask')" width="780px" ref="shareProjectTaskModal" class="modal" v-on:close="closeShareModal">
      <!--<h1>Share Project Task</h1>-->
      <!--<el-form label-position="top" :model="formShareProjectTask" status-icon :rules="rules" ref="formShareProjectTask" label-width="0" class="demo-ruleForm">-->
        <!--<el-form-item prop="email" label="E-mail">-->
          <!--<el-input @keyup.enter.native="shareProjectTaskSubmit()" placeholder="E-mail" v-model="formShareProjectTask.email"></el-input>-->
        <!--</el-form-item>-->
        <!--<div class="flex-center">-->
          <!--<el-form-item>-->
            <!--<el-button @click="shareProjectTaskSubmit()" class="modal__btn" type="primary" plain size="medium">Share</el-button>-->
          <!--</el-form-item>-->
        <!--</div>-->
      <!--</el-form>-->

          <form-wizard
                  shape="tab"
                  ref="wizard"
                  :start-index="0"
                  step-size="xs"
                  :color="color"
                  @on-change="handleTabChange"
                  @on-validate="handleValidation"
                  error-color="#f56c6c"
                  validate-on-back
                  title=""
                  subtitle=""
                  @on-complete="onComplete">
              <!--:before-change="() => beforeTabSwitch(formShareProjectTask.email)"-->
              <tab-content :title="$t('modal_email')"
                         icon="el-icon-edit-outline"
                         :before-change="validateFirstStep">
                  <el-form @submit.prevent.native="validateFirstStep"  label-position="top" :model="formShareProjectTask" status-icon :rules="rules" ref="formShareProjectTask" label-width="0" class="demo-ruleForm">
                      <el-form-item prop="email">
                            <el-input :label="$t('modal_userName')" v-model="formShareProjectTask.email"></el-input>
                      </el-form-item>
                  </el-form>
            </tab-content>
            <tab-content :title="$t('modal_share')"
                         icon="el-icon-check">
                <el-form label-position="top" :model="formSelectedCompany" status-icon :rules="rules2" ref="formSelectedCompany" label-width="0" class="demo-ruleForm">
                    <!--{{formSelectedCompany.companyId}}<br>-->
                    <!--{{formSelectedCompany.companies}}-->
                    <el-form-item prop="companyId" :label="$t('modal_selectCompany')" >
                        <el-select no-data-text="no data" v-model="formSelectedCompany.companyId" :placeholder="$t('modal_selectCompany')" size="small">
                        <el-option
                        v-for="item in formSelectedCompany.companies"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <!--<el-form-item prop="email" label="E-mail">-->
                    <!--<el-select no-data-text="no data" v-model="formShareProjectTask.companyId" placeholder="Select Region" size="small">-->
                        <!--&lt;!&ndash;{{region}}&ndash;&gt;-->
                        <!--<el-option-->
                                <!--v-for="item in formShareProjectTask.companies"-->
                                <!--:key="item.id"-->
                                <!--:label="item.name"-->
                                <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
            </tab-content>
              <el-button type="primary" slot="prev">{{$t('general_back')}}</el-button>
              <el-button  type="primary" slot="next">{{$t('general_next')}}</el-button>
              <el-button type="primary" slot="finish">{{$t('general_submit')}}</el-button>
          </form-wizard>
    </sweet-modal>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import axios from 'axios';
  export default {
    components: {
      SweetModal,

    },
    props: [
      'createProject', 'selectedRowId'
    ],
    mounted() {
      //this.createProjectOpen();
      // this.formCreateProject.startDate = new Date();
    },
    data() {
      return {
        isValid: false,
        isAuth:false,
        nextStepAvaliable:false,
        color:'#f3f2ee',
        step: 0,
        projectTemplates: [
          {
            value: 'Default Template',
            label: 'Default Template'
          },
        ],
        formShareProjectTask: {
          email: '',
        },
        formSelectedCompany:{
          companies: [],
          companyId: ''
        },
        rules: {
          email: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ]
        },
        rules2:{
          companyId: [
            { required: true, message: 'Please input Company', trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      test(){
        console.log('hello')
        return false
      },
      handleTabChange(prevIndex, nextIndex){
        // your logic here
        // console.log(this.VueFormWizard)
        console.log('OnChange', prevIndex, 'nextIndex', nextIndex)
      },
      handleValidation: function(isValid, tabIndex){
        // console.log('Tab: '+tabIndex+ ' valid: '+isValid)
      },
      onComplete: function(){
        let loader = this.$loading.show();
        let data = {
          sharedCompanyId: this.formSelectedCompany.companyId,
          userEmail: this.formShareProjectTask.email
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/sharedProjectTasks/create?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRowId}`, data)
          .then(response => {
            if(response.data.success){
              loader.hide()
              this.notification("Success", "Task Shared", "success")
              // this.$emit('getInfoTask')
              this.$emit('submit', Number(this.$route.query.projectId), false, this.selectedRowId)
              this.closeShareModal()
              this.$refs.shareProjectTaskModal.close()
            }
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          })
      },
      validateFirstStep2() {
        let _that = this
        function resolveAfter2Seconds() {
          return new Promise(resolve => {
            let loader = _that.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectTasks/directories?companyId=${_that.$route.query.companyId}&projectId=${_that.$route.query.projectId}&operation=getUserOwnCompanyList&userEmail=${_that.formShareProjectTask.email}`)
              .then(response => {
                _that.formSelectedCompany.companies = response.data.userOwnCompanyList
                loader.hide()
                _that.color = 'rgb(52, 152, 219)'
                _that.isAuth = true
                _that.nextStepAvaliable = true
                resolve(true);
              })
              .catch(error => {
                loader.hide()
                _that.nextStepAvaliable = false
                _that.color = 'rgb(245, 108, 108)'
                _that.isAuth = false
                console.log('An error occurred:', error);
                resolve(false);
              })

          });
        }

        async function asyncCall() {
          console.log('calling');
          var result = await resolveAfter2Seconds();
          console.log('ressss', result);
          // expected output: 'resolved'
          return result
        }

        return asyncCall();
      },
      validateFirstStep() {
        return new Promise((resolve, reject) => {
          this.$refs.formShareProjectTask.validate((valid) => {
            if(valid){
              let valid2 = this.validateFirstStep2()
              resolve(valid2)
            }
            reject(valid)
          });
        })
      },
      beforeTabSwitch(email){
        let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projectTasks/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&operation=getUserOwnCompanyList&userEmail=${email}`)
            .then(response => {
              this.formSelectedCompany.companies = response.data.userOwnCompanyList
              loader.hide()
              this.color = 'rgb(52, 152, 219)'
              this.isAuth = true
              this.nextStepAvaliable = true
            })
            .catch(error => {
              loader.hide()
              this.nextStepAvaliable = false
              this.color = 'rgb(245, 108, 108)'
              this.isAuth = false
              console.log('An error occurred:', error);
            })
      },
      forceClearError() {
        this.$refs.wizard.tabs[this.activeTabIndex].validationError = null;
      },
      validate(ref) {
        return this.$refs[ref].validate();
      },
      onStepValidate(validated, model) {
        if (validated) {
          this.finalModel = { ...this.finalModel, ...model };
        }
      },
      open() {
        this.shareProjectTaskOpen()
      },
      shareProjectTaskOpen() {
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type,
        });
      },
      // shareProjectTaskSubmit() {
      //   let loader = this.$loading.show();
      //   var _this = this;
      //   var url = `/api/v1/sharedProjectTasks/create?companyId=${this.$route.query.companyId}`;
      //   axios.post(url, {
      //     email: this.formShareProjectTask.email,
      //     projectTaskId: this.selectedRowId
      //   }).then(function (response) {
      //     _this.$refs.shareProjectTaskModal.close();
      //     _this.notification("Success", "Project task shared successful", "success");
      //     _loader.hide();
      //     _loader.hide()
      //     _this.$emit('submit');
      //   }).catch(function (error) {
      //     _this.notification("Notification", error.response.data.message, "info")
      //     _loader.hide()
      //     _loader.hide()
      //   });
      // },
      closeShareModal(){
        this.$refs['formShareProjectTask'].resetFields()
        this.$refs.wizard.navigateToTab(0)
        this.formShareProjectTask.email = ''
        this.formSelectedCompany.companyId = ''
        this.formSelectedCompany.companies = []
        this.color = '#f3f2ee'
        this.isAuth = false
        this.isValid = false
        this.$refs['formSelectedCompany'].resetFields()
      }
    },
    computed:{
          email(){
            return this.formShareProjectTask.email
          }
    },
    watch:{
      // email(val){
      //     this.validateFirstStep().then(data => {
      //       console.log(data)
      //       if(data === true){
      //           this.isValid = true
      //       }else{
      //         this.isValid = false
      //       }
      //     })
      // },
      // isAuth(val){
      //     this.validateFirstStep2()
      //   alert(val)
      // }
    }
  };
</script>

<style lang="less">
    .wizard-title{
        font-size: 1.5em;
        font-weight: bold;
    }
    .stepTitle{
        color: rgba(0,0,0,.6) !important;
    }
    .wizard-nav{
        .wizard-icon{
            color: rgba(0,0,0,.6) !important;
        }
    }

</style>
